export const loadingConstants = {
  SET_LOADING: 'SET_LOADING'
};
